import { Chip } from "@mui/material";
import { CheckCircle2, CircleAlert, Clock3, LoaderCircle } from "lucide-react";

export type UiStatus = "processing" | "needs_review" | "approved" | "failed" | "ready";

const statusConfig = {
  processing: { label: "Processing", color: "primary" as const, icon: <LoaderCircle size={14} /> },
  needs_review: { label: "Needs review", color: "warning" as const, icon: <Clock3 size={14} /> },
  approved: { label: "Approved", color: "success" as const, icon: <CheckCircle2 size={14} /> },
  failed: { label: "Needs attention", color: "error" as const, icon: <CircleAlert size={14} /> },
  ready: { label: "Ready", color: "default" as const, icon: <CheckCircle2 size={14} /> }
};

export function StatusBadge({ status }: { status: UiStatus }) {
  const config = statusConfig[status];
  return <Chip size="small" color={config.color} icon={config.icon} label={config.label} />;
}
